namespace $ {
	export var $mol_crypto_native = crypto
}
